import React, { useRef, useEffect } from "react";
import videoSrc from "../../assets/videos/HeroSection_bgVideo.mp4"; // Video path
import videoSrcFac from "../../assets/videos/HeroSection_bgVideo_fac.mp4"; // Video path
import videoSrcFacDrone from "../../assets/videos/HeroSection_bgVideo_fac_drone.mp4"; // Video path
import anniversaryLogo from "../../assets/images/t_Final logo_dark_v.svg"; // Logo
import HeroSectionPlayButton from "./components/HeroSectionPlayButton";

const HeroSection = () => {
    const videoRef = useRef(null);
    useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5; // Change this to 1.5, 2, 0.5 etc.
    }
  }, []);

  return (
    <div className="relative h-screen flex items-center justify-center text-white overflow-hidden">

      {/* Background Video */}
<div className="">
  <video
    ref={videoRef}
    className="absolute inset-0 w-full h-full object-cover opacity-100 transition-opacity duration-500"
    src={videoSrcFacDrone}
    autoPlay
    loop
    muted
    playsInline
    preload="auto"
  />
  <video
    className="absolute inset-0 w-full h-full object-cover opacity-0"
    src={videoSrcFacDrone}
    autoPlay
    loop
    muted
    playsInline
    preload="auto"
  />
</div>


      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent z-10" />

      {/* Hero Content (Desktop) */}
      <div className="hidden md:flex relative z-20 flex-col items-center justify-center h-full text-center text-white font-montserrat w-screen px-12">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex justify-center">
          {/* <HeroSectionPlayButton /> */}
        </div>
        <div className="flex flex-col items-center justify-center space-y-1 max-w-6xl">
          <div className="flex justify-center">
            <img
              src={anniversaryLogo}
              alt="25 Years Logo"
              className="w-56 h-56 lg:w-80 lg:h-80 object-contain"
            />
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-4xl md:text-6xl lg:text-7xl text-white font-medium leading-tight">
              25 Years of Excellence in Engineering
            </div>
          </div>
        </div>
      </div>

      {/* Hero Content (Mobile) */}
      <div className="flex md:hidden relative z-20 flex-col items-center justify-center h-full text-center text-white font-montserrat w-screen px-8">
        <div className="flex flex-col items-center justify-center space-y-3 w-full">
          <div className="flex justify-center">
            <img
              src={anniversaryLogo}
              alt="25 Years Logo"
              className="w-40 h-40 sm:w-48 sm:h-48 object-contain"
            />
          </div>
          <div className="flex justify-center">
            {/* <HeroSectionPlayButton /> */}
          </div>
          <div className="text-center px-4">
            <div className="text-2xl sm:text-4xl md:text-6xl lg:text-8xl text-white font-medium leading-tight">
              25 Years of Excellence in Engineering
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
